import React from 'react';

import CoproDetailedList from '../../components/Analyzing/CoproDetailedList/CoproDetailedList.module';

function CoproDetailedListView() {
  return (
    <CoproDetailedList />
  );
}

export default CoproDetailedListView;


